// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_G_w","cls2":"LoggedInDiscoveryPage-cls2_ScV LoggedInDiscoveryPage-cls1_G_w"};